import keyMirror from 'keymirror';

const AIRPORT_CODES = keyMirror({
  HAV: null,
});

export default AIRPORT_CODES;
